<div class="container-fluid osp-help">
  <div class="row breadcrumb-wrapper">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="container">
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
                  </div>
              </div>
          </div>
      </div>
  </div>


<section class="buy-can-trust-sec bg-cryan pt-4 pb-2 buy-your-dream">
<div class="container">
  <div class="content-heading d-block d-md-flex align-items-center justify-content-between">
    <h1 class="fw-semibold page-sub-title cv-text-dark">Buy your favourite commercial vehicle in 3 steps</h1>

  </div>

  <div class="row">
    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box">
      <div class="content">
        <div class="icon mb-3">
          <img [src]="environment1 + 'images/new-images/01arrow.svg'" alt="01 arrow" loading="lazy">
        </div>
        <h3 class="cv-text-dark fw-semibold fs-4 font-size-16">Select the commercial vehicle</h3>
        <p class="cv-text-dark-gray font-size-16">From our extensive range of commercial vehicles, choose the vehicle
          that
          better suits your business's requirements</p>
      </div>

    </div>
    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box">
      <div class="content">
        <div class="icon mb-3">
          <img [src]="environment1 + 'images/new-images/02help.svg'" alt="02help" loading="lazy">

        </div>
        <h3 class="cv-text-dark fw-semibold fs-4 font-size-16">Book Online. Easy and Secure</h3>
        <p class="cv-text-dark-gray font-size-16">Safely and securely book your commercial vehicle online at your
          convenience
        </p>
      </div>

    </div>
    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box">
      <div class="content">
        <div class="icon mb-3">
          <img [src]="environment1 + 'images/new-images/03help.svg'" alt="03 help" loading="lazy">
        </div>
        <h3 class="cv-text-dark fw-semibold fs-4 font-size-16">Delivery at your own convenience</h3>
        <p class="cv-text-dark-gray font-size-16">Once your vehicle is financed, delivery order created by financier
          to dealership, all verifications are completed and you have paid the down payment + booking amount, you will
          have your vehicle delivered by a Tata Motors authorised dealer.</p>
      </div>

    </div>
  </div>
</div>
</section>


  <div class="row ">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="container">
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pt-5">
                      <h2 class="page-sub-title cv-text-dark mb-3">
                        <a href="https://www.tatamotors.com/contact-us/" target="_blank" rel="noopener noreferrer"> Contact Us </a>
                      </h2>
                      <address class="details">
                          <p class="dealer-name">
                              Tata Motors Ltd </p>
                          <p class="dealer-address">
                              4th Floor, Ahura Centre
                              82 Mahakali Caves Road
                              MIDC, Andheri East
                              Mumbai - 400093
                          </p>
                          <p class="dealer-contact">
                              <a href="tel: 1800 209 7979"> 1800 209 7979 (Toll free Number)</a>
                          </p>

                          <p class="dealer-email">
                              <a href="mailto:customercare@tatamotors.com">cac@tatamotors.com</a>
                          </p>
                          <p class="d-text">
                              For more details visit
                          </p>
                          <p class="website">
                              <a href="https://www.tatamotors.com/contact-us/"  rel="noopener noreferrer" target="_blank">
                                  https://www.tatamotors.com/contact-us/
                              </a>
                          </p>
                      </address>
                  </div>
                  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 offset-md-1 pt-5">
                      <h2 class="page-sub-title cv-text-dark mb-3">
                          FAQ
                      </h2>
                      <div class="faq mb-4">
                          <div class="accordion accordion-flush" id="faqCollapse">
                              <div class="accordion-item" *ngFor="let faq of helpList | paginate: {
                                  itemsPerPage: itemsPerPage,
                                  currentPage: currentPage,
                                  totalItems: totalItems,
                                  id: 'faq'
                                }; let id = index">
                                  <h2 class="accordion-header" id="faq-1">
                                      <a class="accordion-button collapsed remove" type="button"
                                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="faq-C"
                                          href="#faq-C-{{id}}">
                                          {{faq.question}}
                                      </a>
                                  </h2>
                                  <div id="faq-C-{{id}}" class="accordion-collapse collapse" aria-labelledby="faq-c"
                                      data-bs-parent="#faqCollapse">
                                      <div class="accordion-body">
                                          {{faq.answer}}
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>


                      <div class="padding-wrapper text-center">
                      </div>
                      <div class="paging-custom text-center pt-4">
                          <pagination-controls *ngIf="totalItems > itemsPerPage" (pageChange)="pageChange($event)" previousLabel=" "
                              nextLabel=" " id='faq' [maxSize]="6"></pagination-controls>
                      </div>
                  </div>
              </div>
          </div>
      </div>

</div>
</div>
